import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import OverlayPanel from "./OverlayPanel";
import API from "../config/API";

const MainBody = ({
  selectedReport,
  setSelectedReport,
  selectedReportMessages,
  setSelectedReportMessages,
  pendingReport,
  setPendingReport,
  refreshReportsList,
  userId,
  isLoadingMain,
  setIsLoadingMain,
  isLeftCollapsed,
  isRightCollapsed,
  justSwitchedReport,
  setJustSwitchedReport,
  showSnackbar,
  refreshReportFilesList,
  isLoading,
  setIsLoading,
  buttonStyle,
  spinnerStyle,
  templates, // ✅ ADD THIS
  setTemplates,
  fetchTemplates,
  input,
  setInput,
}) => {
  console.log("🔄 MainBody mounted");
  useEffect(() => {
    return () => {
      console.log("❌ MainBody unmounted");
    };
  }, []);
  console.log("spinner", spinnerStyle);
  const [messages, setMessages] = useState([
    { role: "system", text: "Hello, how can I help you today?" },
  ]);

  const [showOptimizer, setShowOptimizer] = useState(false);
  const bottomRef = useRef(null);
  const [agentStatus, setAgentStatus] = useState("");
  const pollingIntervalRef = useRef(null);
  const [wishlist, setWishlist] = useState([]);
  /* const handleSend = () => {
  if (input.trim() === '') return;

  const userMessage = { sender: 'user', text: input.trim() };
  setSelectedReportMessages(prev => [...prev, userMessage]);
  setInput('');
  setIsLoading(true);

  API.post(`/reports/${selectedReport.report_id}/messages`, {
    text: input.trim(),
    sender: 'user',
    report_id: selectedReport,
  })
    .then(res => {
      const systemMessage = res.data.reply;
      setSelectedReportMessages(prev => [...prev, systemMessage]);
    })
    .catch(err => {
      console.error('Failed to get reply:', err);
      setSelectedReportMessages(prev => [...prev, {
        sender: 'system',
        text: 'Sorry, something went wrong.'
      }]);
    })
    .finally(() => {
      setIsLoading(false);
    });
};*/

  const startPollingStatus = (reportId) => {
    if (pollingIntervalRef.current) {
      console.log("Polling already running");
      return;
    }

    console.log("Starting polling every 5s for", reportId);
    pollingIntervalRef.current = setInterval(async () => {
      try {
        const res = await API.get(`/reports/info/${reportId}`);
        const status = res.data.data.conversation.status || "";
        console.log("[poll] status:", status);

        if (status) {
          setAgentStatus(status);
        }
      } catch (err) {
        console.error("Failed to poll status:", err);
      }
    }, 2000);
  };

  const stopPollingStatus = () => {
    if (pollingIntervalRef.current) {
      console.log("Stopping polling");
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  };

  const toggleFavorite = async (msg) => {
    const id = msg._id;
    const isFavorite = wishlist.includes(id);

    if (isFavorite) {
      setWishlist(wishlist.filter((x) => x !== id));
      try {
        await API.post("/templates/remove", {
          id,
        });
        showSnackbar("Removed from templates.");
      } catch (err) {
        console.error("❌ Failed to remove:", err);
        showSnackbar("Failed to remove from templates.");
      }
      fetchTemplates();
    } else {
      setWishlist([...wishlist, id]);
      try {
        await API.post("/templates/save", {
          id,
          prompt: msg.content,
        });
        showSnackbar("Added to templates!");
      } catch (err) {
        console.error("❌ Failed to save:", err);
        showSnackbar("Failed to save to templates.");
      }
      fetchTemplates();
    }
  };

  const handleSend = async () => {
    if (input.trim() === "") return;

    const userMessage = { role: "user", content: input.trim() };
    const newMessages = [...selectedReportMessages, userMessage];
    setAgentStatus("Jo is on it");
    setSelectedReportMessages(newMessages);
    setInput("");
    setIsLoading(true);
    startPollingStatus(selectedReport.report_id);

    // Check if this is a pending conversation that needs to be created first
    if (pendingReport && selectedReport.title === "") {
      try {
        const newTitle = `${input.trim().slice(0, 40)}...`; // use first message to create title

        const res = await API.post(`/reports`, {
          report_id: selectedReport.report_id,
          title: newTitle,
          user_id: userId,
        });

        const savedReport = res.data;
        console.log(`new conv ${res.data}`);
        setSelectedReport(savedReport);
        //return false;

        //if(pendingReport == false) {

        const replyRes = await API.post(
          `/reports/${selectedReport.report_id}/messages`,
          {
            content: input.trim(),
            role: "user",
          },
        );

        const systemMessage = replyRes.data.reply;
        setSelectedReportMessages((prev) => [...prev, systemMessage]);

        stopPollingStatus();
        setAgentStatus("");

        setPendingReport(false);

        if (refreshReportsList) {
          refreshReportsList();
          refreshReportFilesList();
        }
      } catch (err) {
        console.error("Failed to create new conversation:", err);
        setSelectedReportMessages((prev) => [
          ...prev,
          {
            role: "system",
            content: "Sorry, something went wrong.",
          },
        ]);
        stopPollingStatus();
        setAgentStatus("");
      } finally {
        setIsLoading(false);
      }

      return; // Skip the rest
    }

    // Handle normal message send for existing conversation
    try {
      const res = await API.post(
        `/reports/${selectedReport.report_id}/messages`,
        {
          content: input.trim(),
          role: "user",
        },
      );

      const systemMessage = res.data.reply;
      const userMessageId = res.data.user_message_id;
      //setSelectedReportMessages((prev) => [...prev, systemMessage]);

      setSelectedReportMessages((prev) => {
        const patched = [...prev];
        const userIndex = patched.length - 1;

        if (userIndex >= 0 && patched[userIndex].role === "user") {
          patched[userIndex] = {
            ...patched[userIndex],
            _id: userMessageId, // inject the _id for the heart to show
          };
        }

        return [...patched, systemMessage];
      });

      stopPollingStatus();
      setAgentStatus("");

      if (res.data.reply.file_created == 1) {
        refreshReportFilesList();
      }

      if (justSwitchedReport == true) {
        refreshReportsList();
        setJustSwitchedReport(false);
      }
    } catch (err) {
      console.error("Failed to get reply:", err);
      setSelectedReportMessages((prev) => [
        ...prev,
        {
          role: "system",
          text: "Sorry, something went wrong.",
        },
      ]);
      stopPollingStatus();
      setAgentStatus("");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [selectedReportMessages]);

  useEffect(() => {
    if (templates?.length) {
      const templateMessageIds = templates
        .map((t) => t.message_id)
        .filter((id) => !!id); // clean nulls if any

      setWishlist(templateMessageIds);
    }
  }, [templates]);

  return (
    <div
      style={{
        width: `calc(100% - ${isLeftCollapsed ? 60 : 400}px - ${isRightCollapsed ? 60 : 400}px)`,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {isLoadingMain ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="preloader-wrapper active">
            <div className="spinner-layer spinner-teal-only">
              <div className="circle-clipper left">
                <div className="circle" style={spinnerStyle}></div>
              </div>
              <div className="gap-patch">
                <div className="circle" style={spinnerStyle}></div>
              </div>
              <div className="circle-clipper right">
                <div className="circle" style={spinnerStyle}></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="chat-main no-scrollbar"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "20px",
            backgroundColor: "#f9f9f9",
          }}
        >
          {Array.isArray(selectedReportMessages) &&
            selectedReportMessages.map((msg, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent:
                    msg.role === "user" ? "flex-end" : "flex-start",
                  marginBottom: "10px",
                }}
              >
                <div
                  className="card-panel z-depth-1"
                  style={{
                    whiteSpace: "pre-wrap",
                    backgroundColor:
                      msg.role === "user" ? "#e0e0e0" : "#f5f5f5",
                    borderRadius:
                      msg.role === "user"
                        ? "10px 10px 0 10px"
                        : "10px 10px 10px 0",
                    padding: "12px 16px",
                    maxWidth: "60%",
                    position: "relative", // 👈 makes heart icon work
                  }}
                >
                  {msg.content}

                  {/* ❤️ Wishlist icon for user messages only */}
                  {msg.role === "user" && msg._id && (
                    <span
                      onClick={() => toggleFavorite(msg)}
                      style={{
                        position: "absolute",
                        bottom: "-5px",
                        right: "5px",
                        cursor: "pointer",
                        fontSize: "1.6rem",
                        color: wishlist.includes(msg._id)
                          ? buttonStyle.backgroundColor
                          : "#aaa",
                        userSelect: "none",
                      }}
                      title="Add to Wishlist"
                    >
                      ♥
                    </span>
                  )}
                </div>
              </div>
            ))}

          {agentStatus && (
            <div
              style={{
                alignSelf: "flex-start",
                margin: "20px 0 10px 0",
                padding: "10px 14px",
                backgroundColor: localStorage.getItem("userMainColor"),
                borderRadius: "10px",
                fontStyle: "italic",
                fontSize: "0.95rem",
                color: "#ffffff",
                maxWidth: "60%",
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <span style={{ marginRight: "8px" }}>{agentStatus}</span>
              <span className="typing-dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
              <style>
                {`
                  .typing-dots span {
                    animation: blink 1.2s infinite;
                    opacity: 0;
                    font-weight: bold;
                  }

                  .typing-dots span:nth-child(1) { animation-delay: 0s; }
                  .typing-dots span:nth-child(2) { animation-delay: 0.2s; }
                  .typing-dots span:nth-child(3) { animation-delay: 0.4s; }

                  @keyframes blink {
                    0%, 80%, 100% { opacity: 0; }
                    40% { opacity: 1; }
                  }
                `}
              </style>
            </div>
          )}

          <div ref={bottomRef} />
        </div>
      )}
      {/* Input bar anchored to bottom by flex */}
      <div
        className="chat-input"
        style={{
          background: "#fff",
          padding: "10px 20px",
          borderTop: "1px solid #ccc",
        }}
      >
        <div
          className="input-field"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Box
            sx={{
              flex: 1,
              marginRight: "10px",
              border: "1px solid",
              borderColor: "#ccc",
              borderRadius: "4px",
              overflow: "hidden",
              "& textarea": {
                width: "100%",
                border: "none",
                resize: "vertical",
                padding: "10px",
                minHeight: "100px",
                maxHeight: "500px",
                fontFamily: "inherit",
                fontSize: "1rem",
                outline: "none",
                "&:focus": {
                  outline: "none",
                },
              },
              "&:focus-within": {
                borderColor: buttonStyle.backgroundColor,
                boxShadow: `0 0 0 1px ${buttonStyle.backgroundColor}66`, // subtle glow
              },
            }}
          >
            <textarea
              disabled={isLoading}
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
            />
          </Box>

          <OverlayPanel
            open={showOptimizer}
            onClose={() => setShowOptimizer(false)}
            title="Templates - Prompt Optmizer"
            templates={templates}
            setInput={setInput}
            buttonStyle={buttonStyle}
            fetchTemplates={fetchTemplates}
            showSnackbar={showSnackbar}
            onOptimize={(input) => {
              console.log("🔧 Optimize this:", input);
              // future logic: send to optimizer API
            }}
          />

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              style={buttonStyle}
              className="btn waves-effect waves-light"
              type="button"
              onClick={handleSend}
              disabled={isLoading}
            >
              Send
            </button>
            <button
              style={{
                ...buttonStyle,
              }}
              className="btn waves-effect waves-light"
              type="button"
              onClick={() => setShowOptimizer(true)}
              disabled={isLoading}
            >
              Tools
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBody;
